import { useState, useEffect, useContext } from "react";
import {
  Icon,
  Button,
  Form,
  Input,
  Checkbox,
  Dropdown,
  Message,
} from "semantic-ui-react";
import { getBuildingFloors } from "../../../../constants";
import { AppContext } from "../../../../Context/AppContext";
import "./mdl-add-unit.css";

export default function MDL_ADD_UNIT({
  set_mdl_open,
  building_id,
  add_single_unit,
}) {
  /* VARIABLE DECLARATIONS
	---------------------------------------------------------------------------------*/
  const { userInfo, appVersion, isAppVersionOutdated } = useContext(AppContext);
  const [user] = userInfo;
  const [var_app_version] = appVersion;
  const [, set_is_app_version_outdated] = isAppVersionOutdated;
  const [var_add_unit, set_add_unit] = useState({});
  const [AllFloors, setAllFloors] = useState([]);
  const [form_validation_error, setFormError] = useState({});

  /* EVENT LISTENERS
	---------------------------------------------------------------------------------*/
  useEffect(() => {
    getBuildingFloorsData();
  }, []);

  async function getBuildingFloorsData() {
    const requestHeaders = {
      headers: {
        entityid: user.uuid,
        appversion: var_app_version,
      },
    };
    await fetch(getBuildingFloors + building_id, requestHeaders)
      .then((response) => response.json())
      .then((res) => {
        if (res.code === 200) {
          setAllFloors(res.data);
        } else {
          if (res?.version && res?.version !== var_app_version) {
            set_is_app_version_outdated(true);
          }
        }
      });
  }

  /* EVENT FUNCTIONS
	---------------------------------------------------------------------------------*/
  const onChangeInput = (event) => {
    const { name, value } = event.target;

    // Clone the errors and clear error for current field
    const error_validation = { ...form_validation_error };
    if (error_validation[name]) {
      delete error_validation[name];
    }
    if (error_validation.error) {
      delete error_validation.error;
    }

    // Special validation for expiry_date
    if (name === "expiry_date") {
      const currentDate = new Date().toISOString().split("T")[0]; // yyyy-mm-dd
      const inputDate = value?.trim();

      if (
        !/^\d{4}-\d{2}-\d{2}$/.test(inputDate) ||
        inputDate < currentDate ||
        inputDate.slice(0, 4).length > 4
      ) {
        error_validation.expiry_date = "Invalid expiry date.";
      } else {
        delete error_validation.expiry_date;
      }
    }

    set_add_unit({ ...var_add_unit, [name]: value });
    setFormError(error_validation);
  };

  const add_unit = () => {
    console.log("add unit called");
    if (var_add_unit) {
      console.log("var_add_unit", var_add_unit);
      const { unit, bedroom_count, floor, town_house } = var_add_unit;
      if (validated()) {
        add_single_unit(unit, bedroom_count, town_house, floor);
        set_mdl_open(false);
      }
    }
  };
  function validated() {
    let return_value = true;
    let error_validation = { ...form_validation_error };

    const alphanumericRegex = /^[a-zA-Z0-9\s_-]+$/;

    const floor = var_add_unit.floor?.trim();
    const unit = var_add_unit.unit?.trim();
    const bedroom_count = var_add_unit.bedroom_count?.trim();

    // Validate Floor
    if (!floor) {
      error_validation.floor = "floor cannot be empty.";
      return_value = false;
    } else if (!alphanumericRegex.test(floor)) {
      error_validation.floor = "floor cannot contain special characters.";
      return_value = false;
    }

    // Validate Unit
    if (!unit) {
      error_validation.unit = "Please enter unit number.";
      return_value = false;
    } else if (!alphanumericRegex.test(unit)) {
      error_validation.unit = "Unit number cannot contain special characters.";
      return_value = false;
    }

    if (!bedroom_count) {
      error_validation.bedroom_count = "Please enter bedroom count.";
      return_value = false;
    } else if (!/^\d+$/.test(bedroom_count)) {
      error_validation.bedroom_count = "Bedroom count must be a number.";
      return_value = false;
    }

    setFormError(error_validation);
    return return_value;
  }

  const onChangeFloor = (e, { name, value }) => {
    set_add_unit({ ...var_add_unit, [name]: value });

    const trimmed = value?.toString().trim();
    const isValid = /^[a-zA-Z0-9\s_-]+$/.test(trimmed) && trimmed !== "";

    setFormError((prev) => ({
      ...prev,
      floor: isValid ? null : "Please select a valid floor.",
    }));
  };

  console.log("form_validation_error", form_validation_error);
  /* RENDER APP
	---------------------------------------------------------------------------------*/
  return (
    <>
      <Form
        error={form_validation_error.error ? true : false}
        method="POST"
        onSubmit={add_unit}
      >
        <div className="modal-header">
          <div className="modal-header-title">Add Unit</div>
          <div
            className="modal-header-close"
            onClick={() => set_mdl_open(false)}
          >
            <Icon name="times circle outline" />
          </div>
        </div>
        <div className="modal-content">
          <Form.Group>
            <Form.Field
              id="unit"
              name="unit"
              label="Unit #"
              type="text"
              value={var_add_unit.unit}
              required
              control={Input}
              onChange={onChangeInput}
              error={
                form_validation_error.unit
                  ? { content: form_validation_error.unit, pointing: "above" }
                  : null
              }
            />
          </Form.Group>
          <Form.Group>
            <Form.Field
              id="bedroom_count"
              name="bedroom_count"
              label="Bedroom Count"
              type="text"
              value={var_add_unit.bedroom_count}
              required
              control={Input}
              onChange={onChangeInput}
              error={
                form_validation_error.bedroom_count
                  ? {
                      content: form_validation_error.bedroom_count,
                      pointing: "above",
                    }
                  : null
              }
            />
          </Form.Group>
          <Form.Group>
            <Checkbox
              checked={var_add_unit.manual_floor === "1"}
              toggle
              onChange={(e, { checked }) => {
                checked
                  ? set_add_unit({
                      ...var_add_unit,
                      manual_floor: "1",
                      floor: "",
                    })
                  : set_add_unit({ ...var_add_unit, manual_floor: "0" });
              }}
              label="Manual Floor"
            />
          </Form.Group>
          <Form.Group>
            {var_add_unit.manual_floor === "1" && (
              <Form.Field error={!!form_validation_error.floor}>
                <label>Manual Floor:</label>
                <Input
                  type="text"
                  value={var_add_unit.floor}
                  onChange={(e) => {
                    const value = e.target.value;
                    set_add_unit({ ...var_add_unit, floor: value });

                    const trimmed = value.trim();
                    const isValid =
                      /^[a-zA-Z0-9\s_-]+$/.test(trimmed) && trimmed !== "";

                    setFormError((prev) => ({
                      ...prev,
                      floor: isValid ? null : "floor cannot be empty.",
                    }));
                  }}
                />
                {form_validation_error.floor && (
                  <span style={{ color: "red", fontSize: "0.9em" }}>
                    {form_validation_error.floor}
                  </span>
                )}
              </Form.Field>
            )}
            {var_add_unit.manual_floor !== "1" && (
              <Form.Select
                label="Floors"
                placeholder="Select floor"
                fluid
                required
                value={var_add_unit.floor}
                onChange={onChangeFloor}
                name="floor"
                error={form_validation_error.floor}
                options={AllFloors}
              />
            )}
          </Form.Group>
          <Form.Group>
            <Form.Field>
              <Checkbox
                checked={var_add_unit.town_house === "1"}
                toggle
                onChange={(e, { checked }) => {
                  checked
                    ? set_add_unit({ ...var_add_unit, town_house: "1" })
                    : set_add_unit({ ...var_add_unit, town_house: "0" });
                }}
                label="Townhouse"
              />
            </Form.Field>
          </Form.Group>
        </div>
        <Message error header="Error" content={form_validation_error.error} />
        <div className="modal-footer">
          <Button type="submit" color="red">
            Submit
          </Button>
        </div>
      </Form>
    </>
  );
}
